import { SidebarTrigger } from "@/components/ui/sidebar";
import HospitalSelector from "@/components/ui/HospitalSelector";

export default function Header({ showSelectors = true }: { showSelectors?: boolean }) {
  return (
    <header
      className="w-full flex items-center gap-3 border-b border-[#1a5c38]"
      style={{ minHeight: "56px", padding: "0 16px", backgroundColor: "#0f3d24" }}
    >
      {/* Sidebar toggle */}
      <SidebarTrigger className="h-8 w-8 rounded-lg text-white/70 hover:bg-white/10 hover:text-white transition-colors flex-shrink-0" />

      {/* Brand Logo - mobile only */}
      <div className="flex items-center gap-2 flex-shrink-0 ml-1 md:hidden">
        <div className="h-7 w-7 rounded-lg bg-[#1a7a4a] flex items-center justify-center shadow-sm">
          <span className="text-white font-semibold flex items-baseline" style={{ fontSize: "10px", letterSpacing: "-0.04em" }}>
            MH<span className="text-green-200 font-light ml-0.5" style={{ fontSize: "8px" }}>AI</span>
          </span>
        </div>
      </div>

      {/* Divider */}
      <div className="h-5 w-px bg-white/20 flex-shrink-0 mx-1 md:hidden" />

      {/* Location Selectors */}
      {showSelectors && (
        <div className="flex-shrink-0 min-w-0">
          <HospitalSelector />
        </div>
      )}

      {/* Spacer */}
      <div className="flex-1" />

      {/* Title */}
      <div className="hidden md:flex items-center gap-1.5 flex-shrink-0">
        <span
          className="font-semibold text-sm whitespace-nowrap flex items-baseline text-white"
          style={{ letterSpacing: "-0.01em" }}
        >
          Monitor Health <span className="font-light ml-1 text-white/50" style={{ fontSize: "12px", letterSpacing: "0.02em" }}>AI</span>
        </span>
        <span className="text-sm font-light text-white/40 whitespace-nowrap">
          Dashboard
        </span>
      </div>

      {/* Live indicator */}
      <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white/10 flex-shrink-0 ml-3">
        <span className="relative flex h-1.5 w-1.5 flex-shrink-0">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-green-400" />
        </span>
        <span className="text-[11px] font-medium text-white/80 leading-none">Live</span>
      </div>
    </header>
  );
}